import * as React from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { useDispatch } from "react-redux";
import { IRootThunkDispatch } from "../../redux/store";
import { CloseSnackBar } from "../../redux/common/snackBar/thunk";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

interface SnackBarInterface {
  isOpen: boolean;
  isSuccess: boolean;
  message: string;
}

export default function AddSnackBar(props: SnackBarInterface) {

  const dispatch = useDispatch<IRootThunkDispatch>()
  function handleClose(){
    dispatch(CloseSnackBar())
  };


  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar open={props.isOpen} autoHideDuration={4000} onClose={handleClose}>
        {props.isSuccess ? (
          <Alert severity="success" sx={{ width: "100%" }}>
            {props.message}
          </Alert>
        ) : (
          <Alert severity="error"> {props.message}</Alert>
        )}
      </Snackbar>
    </Stack>
  );
}
